import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {SplunkMessage} from '../shared/model/splunkMessage';
import {ConfigurationService} from './configuration.service';
import {DialogType, FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import {BaseService} from "~/app/core/services/base.service";
import { LoadingIndicatorHelper } from './loading-indicator-helper';
import { lastValueFrom } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  public splunkMsg: SplunkMessage = new SplunkMessage();
  readonly splunkErrorURL = '/util/log';

  constructor(public injector: Injector,
              public configurationService: ConfigurationService,
              public dialogService: FSInvoiceDialogService,
              public loadingIndicator: LoadingIndicatorHelper,
              public baseService: BaseService) {
  }

  async handleError(error) {
    try {
      if (error !== null && error !== undefined) {
        console.warn('OLI.SplunkMsg ->');
        console.error(error.message);

        console.warn('OLI.SplunkStack ->');
        console.error(error.stack);

        console.error(error);
      }
     
      let splunkId = Date.now().toString(36).toUpperCase() + '.' + Math.random().toString(36).substring(2, 8).toUpperCase();    

      const router = this.injector.get(Router);
      const display = ' SPL.ID: ' + splunkId;
      const log = 'SPLID.UI.OLI: ' + splunkId;

      this.splunkMsg.splid = log + ' page=' + router.url;
      this.splunkMsg.message = 'OLI.SplunkMsg: ' + error.message + ' - OLI.SplunkStack: ' + error.stack;

      console.log(this.splunkMsg);

      lastValueFrom(this.generateSplunkId(this.splunkMsg))
        .then(r => console.log(r))
        .catch(e => console.log(e));


      // TODO clean up logic with error dialogs
      if (this.dialogService !== undefined) {
        this.dialogService.openDialog(
          {
            type: DialogType.ERROR,
            title: 'Unexpected Error!',
            content: 'An unexpected error occurred. Please contact Helpdesk. ' + '\n' + display,
            actions: [
              {text: 'Ok', primary: true}
            ],
            width: 400
          }).then(r => r);
      } else {
        alert('An unexpected error occurred. Please contact McLane Helpdesk.' + '\n' + display);
      }

      if (this.loadingIndicator.isLoading) {
        this.loadingIndicator.hide();
      }
    } catch (e) {
      console.error(e);
    }
  }

  public generateSplunkId(splunkMsg: SplunkMessage) {
    const json = JSON.stringify(splunkMsg);
    return this.baseService.postHttpJson(
      'generateSplunkId',
      'error-service',
      this.configurationService.RESTURL_CONNECT_SUPPORT + this.splunkErrorURL,
      json,
      {observe: 'response'});
  }
}
